import { render } from "./LocationProductionReport.vue?vue&type=template&id=fd21d3c0&scoped=true"
import script from "./LocationProductionReport.vue?vue&type=script&lang=js"
export * from "./LocationProductionReport.vue?vue&type=script&lang=js"

import "./LocationProductionReport.vue?vue&type=style&index=0&id=fd21d3c0&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src2914688552/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd21d3c0"]])

export default __exports__